let faceSwap = "/ai-face-swap";
let imageEnhancer = "/ai-image-enhancer";
let imageGenerator = "/ai-image-generator";
let groupSwap = "/ai-group-face-swap";

// pages
let faceSwapParent = "/face-swap";

let pricing = "/pricing";

const allRoutes = {
  home: "/",
  faceSwap: "/ai-face-swap",
  imageEnhancer: "/ai-image-enhancer",
  imageGenerator: "/ai-image-generator",
  groupSwap: "/ai-group-face-swap",
  faceSwapParent: "/face-swap",
  headshotGenerator: "/ai-headshot-generator",
  pricing: "/pricing",
  signin: "/signin",
  about: "/about",
  privacyPolicy: "/privacy-policy",
  refundPolicy: "/refund-policy",
  termsCondition: "/terms-conditions",
  blogs: "/blogs",

  faq: {
    self: "/faq",
    autoPay: "/auto-pay",
    bugReport: "/bug-report",
    generalQuery: "/general-query",
    generativeAi: "/generative-ai",
    paidSubscription: "/paid-subscription",
    faqRefundPolicy: "/refund-policy",
    productFeatures: "/products-features",
  },

  outputView: "/output-view",
};

export { allRoutes };
